import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  editorContainer: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(1),
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.35)' : 'rgba(0, 0, 0, 0.35)',
    },
    '&:focus-within': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.light}40`,
    },
  },
  tituloInputTextoConclusao: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: '1.05rem',
    paddingTop: '10px',
    paddingBottom: '5px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
}))
